// extracted by mini-css-extract-plugin
export default {"modal":"BlockModal_modal__IeqYu","blockTitle":"BlockModal_blockTitle__zi9MP","title":"BlockModal_title__UfIOi","desc":"BlockModal_desc__OnQhG","button":"BlockModal_button__z+9V5"};